export default __webpack_public_path__ + "static/media/d1.197d8266.png";